module.exports = __webpack_public_path__ + "img/icon-arrow-up.b16ed703.svg";